import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';

import { Messages } from '../../codegen/Localize';
import { EntityActionNames, IEntityAction } from '../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { isSingleEmbeddedDatasource } from '../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { IWebEditFlowAction } from '../../spacesPlatform/models/actionNames';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { newFlowForDatasource } from '../actions/NewFlowForDatasourceAction';

export const NewFlowEntityAction: IEntityAction<IContentInfo<'datasource'>, IWebEditFlowAction> = {
  name: EntityActionNames.NewFlow,
  translateName: Messages.newFlow,
  isVisible: (targetItems: IContentInfo[]) => {
    return FeatureFlags.flowDraftsEnabled && !isSingleEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: IWebEditFlowAction, targetItems: IContentInfo[]) =>
      targetItems.length === 1 && availableActions && availableActions.webEditFlow,
  createReduxAction: (targetItems: IContentInfo[]) => {
    if (targetItems.length !== 1) {
      return;
    }

    const item = targetItems[0];
    if (item.contentType === 'datasource') {
      return newFlowForDatasource(item);
    }
  }
};
